export class RoleFormModel {
  constructor(role = {}) {
    this.name = role?.name || "";
    this.description = role?.description || "";
    this.permissions = role?.permissions || [];
  }
}
